import MUICircularProgress, {
  CircularProgressProps as MUICircularProgressProps,
} from '@mui/material/CircularProgress';

export interface Props extends Pick<MUICircularProgressProps, 'size' | 'sx'> {
  'aria-label': string;
  id?: string;
  isBig?: boolean;
  isCentered?: boolean;
  thickness?: 'small' | 'medium';
}

const Loader = ({
  size = 42,
  sx = {},
  thickness = 'medium',
  isBig = false,
  isCentered = false,
  ...otherProps
}: Props) => {
  const computedSize = isBig ? 100 : size;
  const computedSx = {
    mx: isCentered ? 'auto' : undefined,
    display: isCentered ? 'block' : undefined,
    ...sx,
  };

  return (
    <MUICircularProgress
      color="primary"
      size={computedSize}
      sx={computedSx}
      thickness={thickness === 'small' ? 2 : 3}
      {...otherProps}
    />
  );
};

export default Loader;
